export const MODE = {
    single: "single",
    group: "group",
};
